const modifyRetractionResponse = function ({ commit }, { id, field, value }) {
  commit("UPDATE_RETRACTION_RESPONSE", { id, field, value });
};

export default modifyRetractionResponse;
